module.exports = __webpack_public_path__ + "img/tool-check.2de96fd.jpg";